import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ReportserviceService } from 'app/reports/reportservice.service';
import { ExportService } from 'app/reports/services/export.service';
declare const $: any;

@Component({
  selector: 'app-appointment-register-doctor-wise',
  templateUrl: './appointment-register-doctor-wise.component.html',
  styleUrls: ['./appointment-register-doctor-wise.component.scss']
})
export class AppointmentRegisterDoctorWiseComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  fileName = 'ExcelSheet.xlsx';
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate: any;
  enddate;
  pname = "";

  pageHeading: any;
  isShowDivIf: boolean = false;
  isValidDate: any;
  searchDrName: number = 0;
  toDaysDate: any;
  comparesionStartDate: any;
  comparesionEndDate: any;
  DoctorDataArray: any = [];
  patientTotal: number;
  alltotalCount: number;
  RegDoctorWise: any = [];
  doctorid: number;

  constructor(public opdvisitService: OpdVisitService,
    public datepipe: DatePipe, public authService: AuthService,
    public dashboardService: DashboardService, private exportdata: ExportService,
    public reportService: ReportserviceService) { }
  headerName: string[] = ['S.No', 'Date', 'Time', 'UHID', 'Patient Name', 'Case Type', 'Given By'];
  ngOnInit(): void {
    this.pageHeading = 'Appointment Register Doctor Wise Report';
    this.searchDrName = 0;
    this.toDaysDate = this.authService.getServerDate;
    this.toDaysDate = this.datepipe.transform(this.toDaysDate, "yyyy-MM-dd");
    this.comparesionStartDate = this.toDaysDate;
    this.comparesionEndDate = this.toDaysDate;
    this.startdate = this.toDaysDate;
    this.enddate = this.toDaysDate;
    this.doctorid = 0;
    this.appDoctorReportWiselist(this.authService.Loggeduser.branchid, this.startdate, this.enddate, this.doctorid)
  }

  appDoctorReportWiselist(branchid: any, fdate: any, tdate: any, doctid: any) {
    this.RegDoctorWise = [];
    this.alltotalCount = 0;
    this.reportService.getAppointmentRegDocterWiseReport(branchid, fdate, tdate, doctid).subscribe((e: any) => {
      if (e.length > 0) {
        if (this.searchDrName != 0) {
          var x = e.filter(item => item.doctorName == this.searchDrName);
        } else {
          var x = e;
        }

        this.DoctorDataArray = e.reduce((s, { doctorName }) => {
          if (!s.some(o => o.doctorName == doctorName)) {
            s.push({ doctorName });
          }
          return s;
        }, []);

        let groupdata = x.reduce((r, { doctorName }) => {
          if (!r.some(o => o.doctorName == doctorName)) {
            r.push({ doctorName, DoctorItem: x.filter(v => v.doctorName == doctorName) });
          }
          return r;
        }, []);

        for (var i = 0; i < groupdata.length; i++) {
          this.patientTotal = 0;
          this.patientTotal = groupdata[i].DoctorItem.length;;
          this.alltotalCount = this.alltotalCount + this.patientTotal;
          this.RegDoctorWise.push({
            "doctorName": groupdata[i].doctorName,
            "totalamount": this.patientTotal,
            "Useritem": groupdata[i].DoctorItem,
          });
        }
      }
    })
  }

  onOptionsSelected(event: any) {
    this.searchDrName = event.value;
    this.dateSearch();
  }
  dateSearch() {
    let sdate = this.datepipe.transform(this.comparesionStartDate, "yyyy-MM-dd");
    let edate = this.datepipe.transform(this.comparesionEndDate, "yyyy-MM-dd");
    this.startdate = sdate;
    this.enddate = edate;
    this.doctorid = 0;
    this.isValidDate = this.validateDates(sdate, edate);
    if (this.isValidDate != false) {
      this.appDoctorReportWiselist(this.authService.Loggeduser.branchid, this.startdate, this.enddate, this.doctorid);
    } else {
      this.dashboardService.openSnackBar("End date should be greater than start date", "OK");
    }
  }
  validateDates(sDate: string, eDate: string) {
    this.isValidDate = true;
    if ((sDate == null || eDate == null)) {
      this.isValidDate = false;
    }

    if ((sDate != null && eDate != null) && (eDate) < (sDate)) {
      this.isValidDate = false;
    }
    return this.isValidDate;
  }

  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }

  exportexcel(): void {
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, this.pageHeading);
  }


  public openPDF(): void {
    this.startdate = this.authService.getServerDate;
    // this.exportdata.open_loader_Dialogtwo();
    // let DATA = document.getElementById('content');
    // this.exportdata.downloadAsPDF(DATA, this.pageHeading);
    this.exportdata.open_loader_Dialogtwo();
    $("#removeclass").removeClass("grid-scroll");
    let DATA = document.getElementById('content');
    this.exportdata.getexportPDF(DATA, this.pageHeading);
    $("#removeclass").addClass("grid-scroll");

  }
  printPDF():void{
    this.exportdata.printpDFData();
   }
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);

  }
}
